import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SessionStorageService } from 'ngx-webstorage';
//import { EmailComponent } from './../../../../resources/components/modals/email/email.component';
import { DIdentidadAuthConfigServicios, RespuestaGenerica, MediosComunicacionUsuario, MedioComunicacion, SolicitudOTP } from '@dian/api-identidad-auth-config';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { UtilsService } from './../../../../resources/services/utils.service';

export interface Menu {
  tipo: string;
  icono: string;
  iconoSeleccionado: string;
  titulo: string;
  descripcion: string;
  valor: string;
  seleccionado: boolean;
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ UtilsService ]
})
export class MenuComponent implements OnInit {

  public loading: boolean = false;
  public autenticacion: MedioComunicacion[];
  public optionSelected: boolean = false;
	public listMenu:Array<Menu> = new Array<Menu>();
  //public showMessageEmpty: boolean = false;

  private identificacion: string = '';
  private otp: string = '';

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private _rest: DIdentidadAuthConfigServicios,
    private utils: UtilsService
  ) {
   // this.autenticacion = new MedioComunicacion();
  }

  ngOnInit() {
    this.identificacion = localStorage.getItem('identificacion');
    this.autenticacion = <MedioComunicacion[]>JSON.parse(localStorage.getItem('medios-comunicacion'));    
    console.log(this.autenticacion)
    let countRetry = 0;

    const idInterval = setInterval(() => {
      if (this.autenticacion) {
        this.buildMenu();
        clearInterval(idInterval);
      } else {
        countRetry++;
        this.autenticacion = JSON.parse(localStorage.getItem('medios-comunicacion'));
      }

      if (!this.autenticacion && countRetry === 5) {
        //this.loading = false; 
        this.router.navigate(['habilitar-cuenta/autenticacion']);
      }
    }, 500);
  }

  private buildMenu() {
    const opciones = this.autenticacion; 

    /*if (!opciones.length) {
      this.showMessageEmpty = true;
      return;
    } else {*/
      const ICONS = {
        TEL: "./assets/img/svg/celular.svg",
        SELTEL: "./assets/img/svg/b-celular.svg",
        EMAIL: "./assets/img/svg/correo.svg",
        SELEMAIL: "./assets/img/svg/b-correo.svg"
      };

      for (let item of opciones) {
        if (item.tipo === 'email') {
          this.listMenu.push({
            tipo: item.tipo,
            icono: ICONS.EMAIL,
            iconoSeleccionado: ICONS.SELEMAIL,
            titulo: 'Correo electrónico',
            descripcion: 'A la dirección',
            valor: item.valor,
            seleccionado: false
          });
        } else {
          this.listMenu.push({
            tipo: item.tipo,
            icono: ICONS.TEL,
            iconoSeleccionado: ICONS.SELTEL,
            titulo: 'Mensaje de texto',
            descripcion: 'Al número de celular',
            valor: item.valor,
            seleccionado: false
          });
        }    
      } 
    //}

    //this.loading = false; 
  }

  seleccionar(index: number) {
    this.listMenu.map((item) => item.seleccionado = false);
    this.listMenu[index].seleccionado = true;
    this.optionSelected = true;
  }

  public submit() {
    this.loading = true;    
    const itemSeleccionado = this.listMenu.find((item) => item.seleccionado === true);
    const model = new SolicitudOTP();
    const persona = JSON.parse(this.identificacion).usuariocuenta.persona;
    const documento = `${persona.tipoDocumento}-${persona.numDocumento}`;

    //model.documento = this.utils.encryptAES(documento);
    model.documento = this.utils.utf8ToBase64(`${documento}`);
    model.medioRecuperacion = {tipo: itemSeleccionado.tipo, valor: itemSeleccionado.valor};
    
    this._rest.solicitarOTP(model).subscribe(
      res => {
        localStorage.setItem('tipo-comunicacion', JSON.stringify(model.medioRecuperacion));
        this.router.navigate(['/habilitar-cuenta/confirmacion']);
      },
      error => {
        let config = {
          disableClose: true,
          maxWidth: 400,
          data: {
            type: 'warning',
            title: '¡Error al solicitar el código de seguridad! ',
            message: 'Disculpe las molestias. Intente de nuevo.',//error.mensaje,
            textButton: 'Entendido',
            valueButton: 'ok'
          }
        };
        this.dialog.open(NotificationsComponent, config);    
        this.loading = false;
      },
      () => this.loading = false
    );
  }  

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/menu/menu.component.ts